module.exports = __webpack_public_path__ + "img/58.d6ffef27.jpg";